import type { ReactNode } from "react";
import {
  BookOpen,
  Landmark,
  Table2,
  FileSpreadsheet,
  FileText,
  FolderOpen,
  HardDrive,
  Briefcase,
  Users,
  Receipt,
  CreditCard,
  Mail,
  Send,
  Globe,
  Cloud,
  Terminal,
  Workflow,
  Cog,
  Code2,
} from "lucide-react";

export interface TechCategory {
  title: string;
  items: { icon: ReactNode; name: string }[];
}

const icon = (Icon: typeof Code2) => (
  <Icon strokeWidth={1.5} className="w-5 h-5 text-primary" aria-hidden="true" />
);

export const techCategories: TechCategory[] = [
  {
    title: "Books & close",
    items: [
      { icon: icon(BookOpen), name: "QuickBooks Online" },
      { icon: icon(Landmark), name: "Xero" },
      { icon: icon(Table2), name: "Excel" },
      { icon: icon(FileSpreadsheet), name: "Google Sheets" },
    ],
  },
  {
    title: "Client documents",
    items: [
      { icon: icon(FileText), name: "Dext" },
      { icon: icon(FolderOpen), name: "Hubdoc" },
      { icon: icon(HardDrive), name: "Google Drive" },
      { icon: icon(Cloud), name: "Dropbox" },
    ],
  },
  {
    title: "Practice & billing",
    items: [
      { icon: icon(Briefcase), name: "Karbon" },
      { icon: icon(Users), name: "TaxDome" },
      { icon: icon(Receipt), name: "Bill.com" },
      { icon: icon(CreditCard), name: "Stripe" },
    ],
  },
  {
    title: "Email & calendar",
    items: [
      { icon: icon(Mail), name: "Gmail" },
      { icon: icon(Send), name: "Outlook" },
      { icon: icon(Globe), name: "Google Workspace" },
      { icon: icon(Cloud), name: "Microsoft 365" },
    ],
  },
  {
    title: "Automation & glue",
    items: [
      { icon: icon(Terminal), name: "Python" },
      { icon: icon(Workflow), name: "n8n" },
      { icon: icon(Cog), name: "Zapier" },
      { icon: icon(Code2), name: "TypeScript" },
    ],
  },
];
